


































import { IRoom } from "@/@types/hotel/room";
import { IVirtualRooma } from "@/@types/hotel/virtual_rooms";
import { Component, Prop, Vue } from "vue-property-decorator";
import StandartModal from "@/components/app/standart-modal.vue";
@Component({ components: { StandartModal } })
export default class RootVroms extends Vue {
  @Prop({ type: Array, default: () => [] }) vrooms!: Array<IVirtualRooma>;
  @Prop({ type: Array, default: () => [] }) rooms!: Array<IRoom>;

  getRoom(id: string): string {
    const room = this.rooms.find((el) => el._id == id);
    return room ? room.name : "-";
  }

  removeVroom(id: string): void {
    this.$emit("deleteVroom", id);
  }
}
